/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import React from 'react';
import { useTranslation } from 'react-i18next';

import ButtonComponent from '../../../../components/ButtonMC';

import PaymentMethodsList from './PaymentMethodsList';
import OrderHowMessage from './OrderHowMessage';
import TextBlock from './TextBlock';

const SendPaymentLinksContent = ({
  order,
  mainContainerClassName = '',
  containerClassName = '',
  header,
  actionButton = false,
  onSend,
  paymentMethods = [],
  onToggle,
  saving = false
}) => {
  const { t } = useTranslation('Inbox');
  const selectedPaymentMethods = paymentMethods.filter((p) => p.selected);

  return (
    <div className="tw-wrapper">
      <div className={`tw-flex tw-flex-col tw-gap-6 ${mainContainerClassName}`}>
        <div className={`tw-flex tw-flex-col tw-gap-6 tw-overflow-y-auto tw-break-words ${containerClassName}`}>
          {header}
          <div className="tw-flex tw-flex-col tw-gap-6">
            <div className="tw-flex tw-flex-col tw-gap-2">
              <TextBlock
                title={t('sendPaymentLinks.subtitle')}
                description={t('sendPaymentLinks.description')}
              />
              <div className="tw-flex tw-flex-col tw-gap-2.5">
                <PaymentMethodsList
                  methods={paymentMethods}
                  onToggle={onToggle}
                />
              </div>
            </div>

            <OrderHowMessage order={order} paymentMethods={paymentMethods} />
          </div>
        </div>

        {actionButton && (
          <div className="tw-flex tw-px-2">
            <ButtonComponent
              onClick={onSend}
              text={t('sendPaymentLinks.sendLink')}
              className="tw-w-full"
              size="medium"
              variant={selectedPaymentMethods.length ? 'PRIMARY' : 'GRAY'}
              disabled={saving}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SendPaymentLinksContent;
